import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Table, Header, Form } from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import moment from 'moment';

import { MULTI_SUBSCRIPTION_ENABLED } from '../../config';
import ListRow from './ListRow';

class SubscriptionsList extends Component {
  render() {
    const {
      onSelectSubscription,
      subscriptions,
      isDisable,
      customerNotes,
      dealerInfo,
    } = this.props;
    const latestExpiredIds = (() => {
      // Feature flag off — no multi-subscription logic needed, return empty set.
      if (!MULTI_SUBSCRIPTION_ENABLED) return new Set();

      // Collect product names that have at least one active (non-expired) subscription.
      const activeProducts = new Set();
      subscriptions.forEach(sub => {
        const { endDate, productName } = sub;
        const isExpired = !isEmpty(endDate) && moment(endDate).isBefore(moment(), 'day');
        if (!isExpired) activeProducts.add(productName);
      });

      // Group expired subscriptions by product name,
      // skipping products that already have an active subscription.
      const expiredByProduct = {};
      subscriptions.forEach(sub => {
        const { endDate, productName } = sub;
        if (activeProducts.has(productName)) return;
        if (!isEmpty(endDate) && moment(endDate).isBefore(moment(), 'day')) {
          if (!expiredByProduct[productName]) expiredByProduct[productName] = [];
          expiredByProduct[productName].push(sub);
        }
      });

      // For each product group, pick the subscription with the latest endDate.
      // That subscription's id is added to the set — its Actions will stay enabled.
      const ids = new Set();
      Object.values(expiredByProduct).forEach(group => {
        const latest = group.reduce((best, sub) => {
          if (moment(sub.endDate).isAfter(moment(best.endDate))) return sub;
          return best;
        });
        ids.add(latest.id);
      });
      return ids;
    })();

    const listRow = ListRow(onSelectSubscription, isDisable, latestExpiredIds);

    const showDealer = () => {
      if (isEmpty(subscriptions)) {
        return '';
      }

      if (isEmpty(subscriptions[0].dealerName)) {
        return `${subscriptions[0].dealerNumber}`;
      }

      return (
        !isEmpty(subscriptions)
        && `${subscriptions[0].dealerNumber} - ${subscriptions[0].dealerName}`
      );
    };

    const showSubscriptionId = () => {
      return (
        !isEmpty(subscriptions)
        && `Subscription ID: ${subscriptions[0].subscription_id}`
      );
    };

    const showCustomerNotes = () => {
      if (!customerNotes) {
        return '';
      }
      if (
        customerNotes
        && (!customerNotes.message || isEmpty(customerNotes.message))
      ) {
        return '';
      }
      return customerNotes.message;
    };
    const isShowCustomerNotes = () => {
      if (isEmpty(showDealer())) {
        return false;
      }
      return true;
    };

    const headerStyle = {
      display: 'grid',
      justifyContent: 'space-between',
      gridTemplateColumns: 'auto auto',
    };
    const containerStyle = {
      flexDirection: 'row-reverse',
      textAlign: 'right',
    };
    const customerNotesStyle = {
      color: 'rgb(34 36 38 / 52%)',
      textAlign: 'right',
    };
    // with character length is 50 width is 360px is fine but if the length change the width will be change also
    const fieldStyle = {
      textAlign: 'right',
      width: '360px',
    };

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>Product Name</Table.HeaderCell>
        <Table.HeaderCell>Price Start Date</Table.HeaderCell>
        <Table.HeaderCell>Price DS</Table.HeaderCell>
        <Table.HeaderCell>Price PSI LPI</Table.HeaderCell>
        <Table.HeaderCell>Notify Email</Table.HeaderCell>
        <Table.HeaderCell>Network Plus Adjustment</Table.HeaderCell>
        <Table.HeaderCell>Subscription Start Date</Table.HeaderCell>
        <Table.HeaderCell>Subscription End Date</Table.HeaderCell>
        <Table.HeaderCell>Subscription Type</Table.HeaderCell>
        <Table.HeaderCell>Ds Paid PSI</Table.HeaderCell>
        <Table.HeaderCell>Options</Table.HeaderCell>
      </Table.Row>
    );

    return (
      <div>
        <div>
          <Header style={headerStyle}>
            <span>Subscriptions Manager</span>
            <span>{dealerInfo}</span>
            <span />
            <span>{showSubscriptionId()}</span>
          </Header>
          {isShowCustomerNotes() && (
            <Form style={{ paddingRight: '10px' }}>
              <Form.Group widths='two' style={containerStyle}>
                <div style={fieldStyle}>
                  <input
                    style={customerNotesStyle}
                    value={showCustomerNotes()}
                    disabled
                  />
                </div>
              </Form.Group>
            </Form>
          )}
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={subscriptions}
            headerRow={headerRow}
            size='small'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
            data-testid='subscriptions-table'
          />
        </div>
      </div>
    );
  }
}

SubscriptionsList.propTypes = {
  onSelectSubscription: PropTypes.func.isRequired,
  subscriptions: PropTypes.arrayOf(PropTypes.shape({
    dealerName: PropTypes.string,
    dealerNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subscription_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  isDisable: PropTypes.bool,
  customerNotes: PropTypes.shape({
    message: PropTypes.string,
  }),
  dealerInfo: PropTypes.string,
};

SubscriptionsList.defaultProps = {
  subscriptions: [],
  isDisable: false,
  customerNotes: null,
  dealerInfo: '',
};

export default compose(withApollo, withRouter)(SubscriptionsList);
